import { put, call, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
// import ApiService from '../Services/ApiService';
// import AppActions from '../Stores/App/Actions';
import StorageBinProcessActions, {
  StorageBinProcessTypes
} from '../Stores/StorageBinProcess/Actions';

// const getAppStore = state => state.app;

export function* storageBinProcessFetchStorageBinProcess() {
  try {
    yield put(StorageBinProcessActions.storageBinProcessFetchStorageBinProcessLoading(true));

    const result = [
      { proc_type: 'STORAGE_BIN_LIST_01', icon: 'fa fa-cubes' },
      { proc_type: 'STORAGE_BIN_EXCEL_01', icon: 'fa fa-file-excel-o' },
      { proc_type: 'STORAGE_ROW_LIST_01', icon: 'fa fa-cubes' },
      { proc_type: 'STORAGE_BAY_LIST_01', icon: 'fa fa-cubes' },
      { proc_type: 'LOCATION_LIST_01', icon: 'fa fa-cubes' },
      { proc_type: 'STORAGE_TYPE_LIST_01', icon: 'fa fa-cubes' }
    ];
    yield put(StorageBinProcessActions.storageBinProcessFetchStorageBinProcessSuccess(result));

    /*
    const app = yield select(getAppStore);
    const getData = {};

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `site/indexItemFlow/${app.curSiteFlowId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );
    
    if (result.isSuccess === true) {
      yield put(StorageBinProcessActions.storageBinProcessFetchStorageBinProcessSuccess(result.data));
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
    */
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(StorageBinProcessActions.storageBinProcessFetchStorageBinProcessLoading(false));
  }
}

export const saga = [
  takeLatest(
    StorageBinProcessTypes.STORAGE_BIN_PROCESS_FETCH_STORAGE_BIN_PROCESS,
    storageBinProcessFetchStorageBinProcess
  )
];
